module.exports = __webpack_public_path__ + "img/ce55d563a74976ab6ff1817108c6418d.d57b9b8e.png";